import { render, staticRenderFns } from "./OrderManufacturingPage.vue?vue&type=template&id=14042670&scoped=true&"
import script from "./OrderManufacturingPage.vue?vue&type=script&lang=js&"
export * from "./OrderManufacturingPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14042670",
  null
  
)

export default component.exports